import ReactGA from 'react-ga4';
import config from '../config.json';
import assetConstants from '../constants/assetConstants';
import contractSpecConstants from '../constants/contractSpecConstants';
import employeeConstants from '../constants/employeeConstants';
import jobConstants from '../constants/jobConstants';
import loginConstants from '../constants/loginConstants';
import orgConstants from '../constants/organizationConstants';
import pickerConstants from '../constants/pickerConstants';
import reportTagConstants from '../constants/reportTagConstants';
import store from '../reducers/storeRegistration';
const trackPage = page => {
  let trackedPage = page;
  if (typeof page === 'undefined') {
    trackedPage = global.window.location.hash.replace('#/', '/');
  }
  ReactGA.send({
    hitType: 'pageview',
    page: trackedPage
  });
};
const trackEvent = (category, action, trackingLabel) => {
  let label = trackingLabel;
  const _store$getState = store.getState(),
    login = _store$getState.login;
  const user = login.user || {};
  if (typeof label === 'undefined') {
    label = login.customer || '(null)';
    label += '.';
    label += user.user_id || '(null)';
  }
  ReactGA.event({
    category,
    action,
    label
  });
};
const trackEntity = (category, action, trackedItem) => {
  const _store$getState2 = store.getState(),
    login = _store$getState2.login;
  const user = login.user || {};
  let label = login.customer || '(null)';
  label += '.';
  if (typeof trackedItem === 'undefined') {
    label += user.user_id || '(null)';
  } else {
    label += trackedItem || '(null)'; // Entity ID for Saved Object
  }
  ReactGA.event({
    category,
    action,
    label
  });
};
const initialize = () => {
  if (config.trackingID) {
    // Setup the tracking code
    ReactGA.initialize(config.trackingID);

    // Listen for the REDUX actions as they're dispatched
    // (subscribe invokes the callback each time any redux action goes out)
    store.subscribe(() => {
      const pathname = global.window.location.hash.replace('#/', '/');
      const _store$getState3 = store.getState(),
        lastAction = _store$getState3.lastAction.action,
        login = _store$getState3.login;
      switch (lastAction.type) {
        case assetConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Asset Tab', 'View');
          break;
        case reportTagConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Admin Tab', 'Report Tags');
          break;
        case orgConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Admin Tab', 'Organizations');
          break;
        case employeeConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Admin Tab', 'Employees');
          break;
        case contractSpecConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Admin Tab', 'Contract Spec');
          break;
        case loginConstants.LOGIN_SUCCESS:
          trackEvent('Login', 'Success');
          break;
        case loginConstants.LOGIN_FAIL:
          trackEvent('Login', 'Failure', "".concat(login.customer, ".(null)"));
          break;
        case 'REPORT_INDEX_SUCCESS':
          // index is called every time a search filter is modified and when report filters
          // on other pages are called, this only tracks page/tab when on the File Cabinet Tab
          if (pathname === '/file-cabinet') {
            trackPage(pathname);
            trackEvent('File Cabinet Tab', 'View');
          }
          break;
        case 'REPORT_SHOW_SUCCESS':
          trackEvent('Report Edit', 'View');
          break;
        case 'REPORT_SAVE_SUCCESS':
          trackEvent('Report Edit Save', 'Success');
          break;
        case jobConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Admin Tab', 'Jobs');
          break;
        case 'ISSUE_INDEX_SUCCESS':
          // index is called every time a search filter is modified and when issue
          // filters on other pages are called, this only tracks page/tab when on the Issues Tab
          if (pathname === '/issues') {
            trackPage(pathname);
            trackEvent('Issue Tab', 'View');
          }
          break;
        case 'ISSUE_SHOW_SUCCESS':
          trackEvent('Issue', 'View');
          break;
        case 'ISSUE_SAVE_SUCCESS':
          trackEvent('Issue Save', 'Success');
          break;
        case 'DOCUMENT_INDEX_SUCCESS':
          // index is called every time a search filter is modified
          trackPage(pathname);
          trackEvent('Library Tab', 'View');
          break;
        case 'DOCUMENT_SHOW_SUCCESS':
          trackEvent('Document', 'View');
          break;
        case 'DOCUMENT_SAVE_SUCCESS':
          trackEvent('Document Save', 'Success');
          break;

        // picker tool
        case pickerConstants.INDEX_SUCCESS:
          trackPage(pathname);
          trackEvent('Admin Tab', 'Pickers');
          break;
        case pickerConstants.SAVE_ALL_SUCCESS:
          trackEvent('Pickers Save', 'Success');
          break;
        default:
          break;
      }

      // Catch errors. The error object could have different formats, so parse it.
      if (lastAction.type && lastAction.type.indexOf('_FAIL') > -1) {
        const error = lastAction.data || '';
        const messages = [];
        if (error && typeof error === 'string' && error.length) {
          // Just the error text was returned, so just use that.
          messages.push(error);
        } else if (Object.keys(error).length) {
          if (Object.keys(error).includes('error_msg')) {
            messages.push(error.error_msg);
          }
          if (Object.keys(error).includes('error_debug')) {
            if (Object.keys(error.error_debug).includes('message')) {
              messages.push(error.error_debug.message);
            } else {
              messages.push(error.error_debug);
            }
          }
        }
        const action = messages.length ? messages.join(' ') : 'Unknown error.';
        trackEvent('Error', action);
      }
    });
  }
};
export default {
  trackPage,
  trackEvent,
  trackEntity,
  initialize
};